import React from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import Main from "common/mdc/layout";
import DateTime from "common/components/dateTime";
import { connect } from "react-redux";
import { compose } from "ramda";
import { Primary } from "common/mdc/layout";
import CollectionWrapper from "common/mdc/wrappers/collection";
import Button from "common/mdc/button";
import { selectors, actions } from "@sma/store/device/tagsHistory";
import { Link } from "found";
import TagPill from "@sma/components/tag/TagPill";

import Table, {
  TableRow,
  TableCell,
  TableHead,
  TableActionCell,
} from "common/mdc/table";
import Menu, { MenuItem } from "common/mdc/menu";
import Dialog, { withConfirmationDialog } from 'common/mdc/dialog';
import { actions as deviceSearchActions } from '@sma/store/device/search';
import { actions as deviceActions } from "@sma/store/device/devices";
import { actions as tagActions } from "@sma/store/tag/tags";
import Pagination from 'common/mdc/table/pagination';

const messages = defineMessages({
  title: {
    id: "title.tagsHistory",
    defaultMessage: "Tags",
  },
  tagsSummary: {
    id: "tags.pagination.tagsHistorySummary",
    defaultMessage:
      "{count, number} {count, plural, one {tag} other {tags}} of {total} displayed",
  },
  noTags: {
    id: "tags.tagsHistoryNoTags",
    defaultMessage: "No tags history found",
  },
  tagsLoading: {
    id: "tags.tagsHistoryLoading",
    defaultMessage: "Tags loading",
  },
  tagsPerPage: {
    id: "tags.tagsHistoryPerPage",
    defaultMessage: "Tags per page",
  },
  detachFromHistory: {
    id: 'device.dialogs.detachingTag.detachFromHistory',
    defaultMessage: 'Are you sure, you want to detach?',
  }
});

class MeterTagHistory extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);

    this.state = {
      limit: 10,
      offset: 0,
    };
  }

  handlePageChange({limit, offset}){
    const { params:{deviceId} } = this.props;
    this.setState({limit, offset},()=>{
      const pageNum = offset === 0 ? 1 : (offset/limit+1);
      this.props.load(deviceId, pageNum, [], limit);
    });
  }

  handleLoadMore() {
    const { params:{deviceId} } = this.props;
    this.props.load(deviceId, this.props.pageNumber + 1, this.props.data);
  }

  handleTagFilter(namespace, label, tagId){
    this.props.advancedToggleExpanded ? null : this.props.toggleAdvancedSearch();
    this.props.clearCriteria();
    this.props.addCriteria({
      property: "tagId",
      nullable: true,
      type: "plain",
      label:{
        key: null,
        ref: null,
        props: {
          id: "meter.search.advanced.tags",
          defaultMessage: "Tags"
        }
      }
    });
    this.props.devicesFilterByTag(`${namespace}:${label}`);
    this.props.setValue({
      nullable: true,
      property: "tagId",
      type: "plain",
      constraints:[{operator: "=", value: tagId}],
    }, 0, tagId);
    this.props.applyCriteria({
      nullable: true,
      property: "tagId",
      type: "plain",
    });
  }

  render() {
    const {
      tagsHistoryContext,
      loading,
      data,
      total,
      detachDialog,
      detachAction,
    } = this.props;
    const { params:{deviceId} } = this.props;
    const isMeterTagHistory = true;
    const { offset, limit } = this.state;
    return (
      <Main>
        <Primary loading={loading}>
          <CollectionWrapper
            loading={loading}
            context={tagsHistoryContext}
            pagination={
              <Pagination
                onChange={this.handlePageChange}
                itemsPerPage={messages.tagsPerPage}
                limit = {limit}
                offset = {offset}
                total = {total}
              />
            }
            messages={{
              loading: <FormattedMessage {...messages.tagsLoading} />,
              empty: <FormattedMessage {...messages.noTags} />,
              summary: (count) => (
                <FormattedMessage
                  values={{ count, total }}
                  {...messages.tagsSummary}
                />
              ),
            }}
          >
            <Table>
              <TableHead>
                <TableCell
                  title={"Tag"}
                  style={{
                    minWidth: "180px",
                    maxWidth: "275px",
                  }}
                >
                  Tag
                </TableCell>
                <TableCell title={"Attached at"} alignRight>
                  Attached at
                </TableCell>
                <TableCell title={"Detached at"} alignRight>
                  Detached at
                </TableCell>
                <TableCell actions title={"Actions"}>
                  Actions
                </TableCell>
              </TableHead>
              {data
                ? data.map((obj) => (
                    <TableRow key={obj.tagId}>
                <TableCell title={`${obj.namespace} -- ${obj.label}`} style={{ maxWidth: "275px" }}>
                  <Link
                    to={`/devices`} style={{ textDecoration: "none" }}
                    onClick={()=>this.handleTagFilter(obj.namespace, obj.label, obj.tagId)}
                  >
                    <TagPill
                      nameSpace={obj.namespace}
                      label={obj.label}
                    />
                  </Link>
                </TableCell>
                <TableCell>
                    <DateTime value={obj.attached} seconds />
                </TableCell>
                <TableCell>
                    {obj.detached === null ? "-" : <DateTime value={obj.detached} seconds />}
                </TableCell>
                <TableActionCell>
                  <Menu>
                    {obj.type === "SYSTEM" ? (
                      <MenuItem
                        onClick={() =>
                          detachDialog({
                            resolve: () =>
                              detachAction({
                                meters: [deviceId],
                                tags: [obj.tagId],
                              }, isMeterTagHistory, obj.uniqueId),
                          })
                        }
                        disabled={obj.detached !== null}
                      >
                        Detach
                      </MenuItem>
                    ) : (
                      <MenuItem
                        onClick={() =>
                          detachAction({
                            meters: [deviceId],
                            tags: [obj.tagId],
                          }, isMeterTagHistory, obj.uniqueId)
                        }
                        disabled={obj.detached !== null}
                      >
                        Detach
                      </MenuItem>
                    )}
                  </Menu>
                </TableActionCell>
              </TableRow>
                  ))
                : null}
            </Table>
          </CollectionWrapper>
        </Primary>
      </Main>
    );
  }
}

const DetachDialog = ({ buttons, onClose }) => (
  <Dialog
    title={"Detach Tag?"}
    buttons={buttons}
    onClose={onClose}
  >
    <FormattedMessage {...messages.detachFromHistory} />
  </Dialog>
);

DetachDialog.propTypes = {};

export default compose(
  connect(
    (state) => {
      return {
        tagsHistoryContext: selectors.getTagsHistoryContext(state),
        loading: selectors.isLoading(state),
          data: state.device.tagsHistory.data,
          total: state.device.tagsHistory.total,
          pageNumber: state.device.tagsHistory.pageNumber,
          advancedToggleExpanded: state.device.search.expanded,
      };
    },
    {
      load: actions.load,
      toggleAdvancedSearch: deviceSearchActions.toggleExpand,
      addCriteria: deviceSearchActions.addCriteria,
      devicesFilterByTag: deviceActions.devicesFilterByTag,
      setValue: deviceSearchActions.setValue,
      clearCriteria: deviceSearchActions.clear,
      applyCriteria: deviceSearchActions.applyCriteria,
      detachAction: tagActions.detach,
    }
  ),
  injectIntl,
  withConfirmationDialog(DetachDialog, 'detachDialog'),
)(MeterTagHistory);
